import React from 'react'
import classNames from 'classnames'
import { selectCrossClientFilter, selectCrossClientResults, setCrossClientResultsMatchFilter } from '../../../../store/crossClient/crossClientResults'
import { CrossClientQueryResultMatch, CrossClientQueryResultMatches } from '../../../../models/CrossClient'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'

const ALL_MATCHES: CrossClientQueryResultMatch[] = Object.values(CrossClientQueryResultMatches)

export const CrossClientMatchFilter = () => {
  return (
    <div className='d-flex p-1 gap-1 align-items-center zocks-bg-color-gray-100 border border-1 zocks-border-color-gray-200 zocks-border-0.5'>
      {ALL_MATCHES.map((match) => (
        <IndividualMatchFilter key={match} match={match} />
      ))}
    </div>
  )
}

interface IndividualMatchFilterProps {
  match: CrossClientQueryResultMatch
}
const IndividualMatchFilter: React.FC<IndividualMatchFilterProps> = ({ match }) => {
  const dispatch = useAppDispatch()

  const filter = useAppSelector(selectCrossClientFilter).matches
  const results = useAppSelector(selectCrossClientResults)

  const selected = filter.includes(match)
  const count = results.filter((result) => result.match === match).length

  const handleSelect = () => {
    if (filter.includes(match)) {
      if (filter.length > 1) {
        dispatch(setCrossClientResultsMatchFilter(filter.filter((f) => f !== match)))
      }
    } else {
      dispatch(setCrossClientResultsMatchFilter([...filter, match]))
    }
  }

  return <MatchFilterButton label={match} count={count} selected={selected} handleSelect={handleSelect} />
}

interface MatchFilterButtonProps {
  label: string
  count: number
  selected?: boolean
  handleSelect?: () => void
}

const MatchFilterButton: React.FC<MatchFilterButtonProps> = ({ label, count, selected, handleSelect }) => {
  return (
    <div
      className={classNames('d-flex gap-2 px-2 py-1', { 'border border-1 zocks-border-color-gray-300 zocks-border-0.5 zocks-text-primary bg-white': selected })}
      role='button'
      onClick={handleSelect}
    >
      <div className='paragraph-small medium'>{label}</div>
      <div
        className={classNames('paragraph-extra-small medium d-flex align-items-center px-1 zocks-border-0.25', {
          'zocks-bg-color-primary-light': selected,
          'zocks-bg-color-gray-200 zocks-text-gray-600': !selected,
        })}
      >
        {count}
      </div>
    </div>
  )
}
